import type { Translation } from '../useTranslation'

export type FormTranslationType = {
  add: string,
  all: string,
  apply: string,
  back: string,
  cancel: string,
  change: string,
  clear: string,
  click: string,
  clickToCopy: string,
  close: string,
  confirm: string,
  copy: string,
  copied: string,
  create: string,
  decline: string,
  delete: string,
  discard: string,
  discardChanges: string,
  done: string,
  edit: string,
  enterText: string,
  error: string,
  exit: string,
  fieldRequiredError: string,
  invalidEmailError: string,
  less: string,
  loading: string,
  maxLengthError: string,
  minLengthError: string,
  more: string,
  next: string,
  no: string,
  none: string,
  of: string,
  optional: string,
  pleaseWait: string,
  previous: string,
  remove: string,
  required: string,
  reset: string,
  save: string,
  saved: string,
  search: string,
  select: string,
  selectOption: string,
  show: string,
  showMore: string,
  showLess: string,
  submit: string,
  success: string,
  unsavedChanges: string,
  unsavedChangesSaveQuestion: string,
  update: string,
  yes: string,
}

export const formTranslation: Translation<FormTranslationType> = {
  en: {
    add: 'Add',
    all: 'All',
    apply: 'Apply',
    back: 'Back',
    cancel: 'Cancel',
    change: 'Change',
    clear: 'Clear',
    click: 'Click',
    clickToCopy: 'Click to Copy',
    close: 'Close',
    confirm: 'Confirm',
    copy: 'Copy',
    copied: 'Copied',
    create: 'Create',
    decline: 'Decline',
    delete: 'Delete',
    discard: 'Discard',
    discardChanges: 'Discard Changes',
    done: 'Done',
    edit: 'Edit',
    enterText: 'Enter text here',
    error: 'Error',
    exit: 'Exit',
    fieldRequiredError: 'This field is required.',
    invalidEmailError: 'Please enter a valid email address.',
    less: 'Less',
    loading: 'Loading',
    maxLengthError: 'Maximum length exceeded.',
    minLengthError: 'Minimum length not met.',
    more: 'More',
    next: 'Next',
    no: 'No',
    none: 'None',
    of: 'of',
    optional: 'Optional',
    pleaseWait: 'Please wait...',
    previous: 'Previous',
    remove: 'Remove',
    required: 'Required',
    reset: 'Reset',
    save: 'Save',
    saved: 'Saved',
    search: 'Search',
    select: 'Select',
    selectOption: 'Select an option',
    show: 'Show',
    showMore: 'Show more',
    showLess: 'Show less',
    submit: 'Submit',
    success: 'Success',
    update: 'Update',
    unsavedChanges: 'Unsaved Changes',
    unsavedChangesSaveQuestion: 'Do you want to save your changes?',
    yes: 'Yes',
  },
  de: {
    add: 'Hinzufügen',
    all: 'Alle',
    apply: 'Anwenden',
    back: 'Zurück',
    cancel: 'Abbrechen',
    change: 'Ändern',
    clear: 'Löschen',
    click: 'Klicken',
    clickToCopy: 'Zum kopieren klicken',
    close: 'Schließen',
    confirm: 'Bestätigen',
    copy: 'Kopieren',
    copied: 'Kopiert',
    create: 'Erstellen',
    decline: 'Ablehnen',
    delete: 'Löschen',
    discard: 'Verwerfen',
    discardChanges: 'Änderungen Verwerfen',
    done: 'Fertig',
    edit: 'Bearbeiten',
    enterText: 'Text hier eingeben',
    error: 'Fehler',
    exit: 'Beenden',
    fieldRequiredError: 'Dieses Feld ist erforderlich.',
    invalidEmailError: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
    less: 'Weniger',
    loading: 'Lädt',
    maxLengthError: 'Maximale Länge überschritten.',
    minLengthError: 'Mindestlänge nicht erreicht.',
    more: 'Mehr',
    next: 'Weiter',
    no: 'Nein',
    none: 'Nichts',
    of: 'von',
    optional: 'Optional',
    pleaseWait: 'Bitte warten...',
    previous: 'Vorherige',
    remove: 'Entfernen',
    required: 'Erforderlich',
    reset: 'Zurücksetzen',
    save: 'Speichern',
    saved: 'Gespeichert',
    search: 'Suche',
    select: 'Select',
    selectOption: 'Option auswählen',
    show: 'Anzeigen',
    showMore: 'Mehr anzeigen',
    showLess: 'Weniger anzeigen',
    submit: 'Abschicken',
    success: 'Erfolg',
    update: 'Update',
    unsavedChanges: 'Ungespeicherte Änderungen',
    unsavedChangesSaveQuestion: 'Möchtest du die Änderungen speichern?',
    yes: 'Ja',
  }
}
